/* eslint-disable @typescript-eslint/no-non-null-assertion,@typescript-eslint/consistent-type-assertions */
import type { ActionTemplateSearchResource } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import BuiltinActionTemplateList from "~/areas/library/components/StepTemplates/BuiltinActionTemplateList";
import { repository } from "~/clientInstance";
import type { DataBaseComponentState } from "~/components/DataBaseComponent/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent/DataBaseComponent";
import FilterSearchBox from "~/components/FilterSearchBox/FilterSearchBox";
import { PageContent } from "~/components/PageContent/PageContent";
import styles from "./style.module.less";
interface SelectBuiltInStepTemplatePageProps {
    spaceId: string;
}
interface SelectBuiltInStepTemplatePageState extends DataBaseComponentState {
    templates: ActionTemplateSearchResource[];
    isLoaded: boolean;
    filterText?: string;
}
export class SelectBuiltInStepTemplatePage extends DataBaseComponent<SelectBuiltInStepTemplatePageProps, SelectBuiltInStepTemplatePageState> {
    constructor(props: SelectBuiltInStepTemplatePageProps) {
        super(props);
        this.state = {
            templates: null!,
            isLoaded: false,
            filterText: null!,
        };
    }
    async componentDidMount() {
        await this.doBusyTask(async () => {
            const templates = await repository.ActionTemplatesV2.search();
            this.setState({
                templates: templates.filter((t) => t.IsBuiltIn),
                isLoaded: true,
            });
        });
    }
    render() {
        return (<PageContent header={{
                title: "Choose Step Template",
                breadcrumbs: [{ label: "Step Templates", pageUrl: links.stepTemplatesPage.generateUrl({ spaceId: this.props.spaceId }) }],
            }} filters={{
                inputs: [
                    <FilterSearchBox placeholder="Filter by name, category or description..." onChange={(value) => this.setState({ filterText: value.toLowerCase() })} fullWidth={true} autoFocus={true} containerClassName={styles.filterSearchBoxContainer}/>,
                ],
            }} busy={this.state.busy} errors={this.errors}>
                {this.state.isLoaded && (<BuiltinActionTemplateList templates={this.state.templates} onPostSelectionUrlRequested={(template) => {
                    const actionType = typeof template === "object" ? template.Type : template;
                    return links.createStepTemplatePage.generateUrl({ spaceId: this.props.spaceId, actionType });
                }} filter={this.state.filterText}/>)}
            </PageContent>);
    }
    static displayName = "SelectBuiltInStepTemplatePage";
}
